import type { FeedbackSubmission } from '@ctw/shared/api/feedback/feedback-manager';
import type { CtwFetchFn } from '@ctw/shared/context/ctw-context';
import { type Env, getBffApiBaseUrl } from '@ctw/shared/utils/environments';

export type SubmitFeedbackSubmissionAttributes = Omit<
  FeedbackSubmission,
  'id' | 'submittedAt' | 'submitterName' | 'submitterEmail'
>;

export interface SubmitFeedbackSubmissionArgs {
  ctwFetch: CtwFetchFn;
  env: Env;
  authToken: string;
  attributes: SubmitFeedbackSubmissionAttributes;
}

/**
 * Posts a feedback submission to the BFF API, returning the raw `ok`/`data` fetch result so
 * callers keep their own success/error handling.
 */
export const submitFeedbackSubmission = ({
  ctwFetch,
  env,
  authToken,
  attributes,
}: SubmitFeedbackSubmissionArgs): ReturnType<CtwFetchFn> => {
  const url = `${getBffApiBaseUrl(env)}/v1/feedback`;

  return ctwFetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({
      data: {
        type: 'feedback-submission',
        attributes,
      },
    }),
  });
};
